/*eslint-disable*/
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {
  IconButton,
  InputBase,
  Paper,
  TextField,
  Typography,
  SxProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface CustomizedInputBaseProps {
  placeholder: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}

export const StyledTextField = styled(TextField)(({ theme }: any) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    height: '1.5rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.5rem !important',
      padding: '0.313rem 0.438rem !important',
    },
  },
  [theme.breakpoints.up('lg')]: {
    height: '1.85rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.625rem !important',
      padding: '0.313rem 0.438rem !important',
    },
  },
  [theme.breakpoints.up('xl')]: {
    height: '2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.813rem !important',
      padding: '0.344rem 0.875rem !important',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    height: '2.2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.938rem !important',
      padding: '0.344rem 0.875rem !important',
    },
  },
}));

export const CustomizedTextField = styled(TextField)(({ theme }: any) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    height: '2.2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.5rem !important',
      padding: '0.225rem 1.525rem !important',
      // padding: '0.313rem 0.438rem !important',
    },
  },
  [theme.breakpoints.up('lg')]: {
    height: '2.2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.825rem !important',
      padding: '3.125 3.125 !important',
    },
  },
  [theme.breakpoints.up('xl')]: {
    height: '2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '1rem !important',
      padding: '1.125rem 1.125rem !important',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    height: '2.7rem !important',
    '& .MuiInputBase-input': {
      fontSize: '1.0rem !important',
      padding: '0.5rem 0.763rem !important',
      backgroundColor: 'none',
      border: '0.188rem solid white',
    },
  },
}));

export function SearchBar({
  placeholder = 'Search Details',
  onChange,
  sx,
}: CustomizedInputBaseProps) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Paper
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: { xxl: 300, xl: 250 },
        border: isFocused ? '2px solid #2a6cb6' : '2px solid #e2e1e5',
        borderRadius: '4px',
        boxShadow: 'none !important',
        ...sx,
      }}
    >
      <InputBase
        sx={{
          ml: 1,
          flex: 1,
          fontFamily: '"Inter", sans-serif',
          fontSize: {
            md: '0.8rem',
            xxl: '1rem',
          },
          '&::placeholder': {
            color: '#7b8898 !important',
          },
        }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': placeholder }}
        onChange={onChange}
        onFocus={handleFocus}  
        onBlur={handleBlur} 
      />
      <IconButton
        type="button"
        sx={{
          p: '5px',
          color: '#5b6067',
        }}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}


export const ResponsiveTextField = styled(TextField)(({ theme }: any) => ({
  width: '100%',
  borderRadius: '8px !important',

  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',

    '& fieldset': {
      borderColor: '#ccc',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#0052cc',
      borderWidth: '1px',
    },

    '&:hover fieldset': {
      borderColor: '#0052cc',
      borderWidth: '1px',
    },

    '&.Mui-disabled fieldset': {
      borderColor: '#bbbbbb',
    },
  },

  '& .MuiOutlinedInput-input': {
    '&::placeholder': {
      color: '#636363 !important',
      fontWeight: '400',
    },
  },

  [theme.breakpoints.up('md')]: {
    height: '1.5rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.8rem !important',
      padding: '9px 9px !important',
    },
  },
  [theme.breakpoints.up('lg')]: {
    height: '2.1rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.9rem !important',
      padding: '9px 9px !important',
    },
  },
  [theme.breakpoints.up('xl')]: {
    height: '2.2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '0.8rem !important',
      padding: '11px 11px !important',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    height: '2.2rem !important',
    '& .MuiInputBase-input': {
      fontSize: '1rem !important',
      padding: '11px 11px !important',
    },
  },
}));

export const StyledTypography = styled(Typography)(({ theme }: any) => ({
  fontWeight: 400,
  [theme.breakpoints.up('xs')]: {
    fontSize: '0.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '0.55rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '0.8rem',
  },
  [theme.breakpoints.up('xxl')]: {
    fontSize: '1rem',
  },
}));
